import { privateGateway } from '../../../config';

export const fetchBookmarksCount = async (): Promise<number> => {
  const response = await privateGateway(
    process.env.REACT_APP_DOCUMENTS_API as string
  ).get('/bookmarks?$top=1&$skip=0&$count=true');

  return response.data?.count || 0;
};
